import {Injectable} from "@angular/core";
import {AuthService} from "../auth/auth.service";
import {TranslateService} from "@ngx-translate/core";
import {catchError, from, map, Observable} from "rxjs";
import {Router} from "@angular/router";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {GeolocationModalComponent} from "../../../components/geolocation-modal/geolocation-modal.component";
import {StorageKeysEnum} from "../../storage/storage-keys.enum";

@Injectable({providedIn: "root"})
export class GeolocationService {

    public locationControl: boolean = false;
    errorMessage = '';
    modalRef!: NgbModalRef;
    hasGeolocationPermission = true


    constructor(
        private authService: AuthService,
        private translate: TranslateService,
        private router: Router,
        private modalService: NgbModal
    ) {
    }


    showGeolocationModal() {
        this.modalRef = this.modalService.open(GeolocationModalComponent)
        this.modalRef.componentInstance.modalRef = this.modalRef;
        return this.modalRef;
    }

    closeGeolocationModal() {
        this.modalRef.close();
    }


    hasLocationPermission(): Observable<boolean> {
        return from(this.checkLocationPermission()).pipe(
            map(position => {
                if (position) {
                    this.updateCoords(position);
                }
                return true;
            }),
            catchError(error => {
                this.hasGeolocationPermission = false;
                console.error('Error checking location permission:', error);
                return from(Promise.resolve(false));
            })
        );
    }


    checkLocationPermission(): Promise<GeolocationPosition | null> {
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    resolve(position)
                },
                (error) => {
                    if (error.code === 1) {
                        reject(null)
                    } else {
                        resolve(null)
                    }
                },
                {timeout: 3000, maximumAge: 0}
            );
        });
    }

    private updateCoords(position: GeolocationPosition): void {
        const coords = {
            lat: position.coords.latitude,
            lon: position.coords.longitude
        };
        const actualCoordsString = sessionStorage.getItem(StorageKeysEnum.COORDS);
        const actualCoords = actualCoordsString ? JSON.parse(actualCoordsString) : {};
        if (actualCoords?.lat !== coords.lat || actualCoords?.lon !== coords.lon) {
            sessionStorage.setItem(StorageKeysEnum.COORDS, JSON.stringify(coords));
        }
    }

}
